import { Text, TextTypography } from '../Text/Text';
import { HorizontalAlignment, VerticalAlignment } from './types';
import { makeStyles } from '@material-ui/core';
import Cropper from 'cropperjs';
import React from 'react';

interface StyleParams {
    horizontalAlignment: HorizontalAlignment;
    verticalAlignment: VerticalAlignment;
    color: string;
    cropBoxData: Cropper.CropBoxData;
    zoom: number;
}

const PADDING = 24;

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: (params: StyleParams) => params.cropBoxData.height,
        justifyContent: (params: StyleParams) => params.verticalAlignment,
        overflow: 'hidden',
        transform: (params: StyleParams) => `translate(${params.cropBoxData.left}px, ${params.cropBoxData.top}px)`,
        width: (params: StyleParams) => params.cropBoxData.width,
    },
    textWrapper: {
        padding: (params: StyleParams) => params.zoom * PADDING,
    },
    text: {
        color: (params: StyleParams) => params.color,
        fontSize: (params: StyleParams) => 18,
        lineHeight: (params: StyleParams) => 1.17,
        [theme.breakpoints.down(321)]: {
            fontSize: (params: StyleParams) => 12,
            lineHeight: (params: StyleParams) => 1.17,
        },
        overflow: 'hidden',
        textAlign: (params: StyleParams) => params.horizontalAlignment,
        textOverflow: 'ellipsis',
        transformOrigin: 'top left',
        transition: '0.1s ease color',
        whiteSpace: 'pre',
    },
}));

export interface GalleryDialogBannerOverlayProps {
    text: string;
    horizontalAlignment: HorizontalAlignment;
    verticalAlignment: VerticalAlignment;
    color: string;
    cropBoxData: Cropper.CropBoxData;
    zoom: number;
}

export const GalleryDialogBannerOverlay = (props: GalleryDialogBannerOverlayProps) => {
    const { text, ...rest } = props;

    const classes = useStyles(rest);

    return (
        <div className={classes.container}>
            <div className={classes.textWrapper}>
                <Text className={classes.text} typography={TextTypography.TITLE_STRONG_CHANGE}>
                    {text}
                </Text>
            </div>
        </div>
    );
};
